import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=13d365ff&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d365ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d365ff')) {
      api.createRecord('13d365ff', component.options)
    } else {
      api.reload('13d365ff', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=13d365ff&scoped=true&", function () {
      api.rerender('13d365ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PWgnDD22HtTH/JS/comp/SearchFilterTokens.vue"
export default component.exports